// New-editor templates save body = null and keep their HTML in body_json.renderedHtml:
// a string from the email builder, {head, body} from the page editors.
export function templateHtml(body: string, bodyJson: any): string {
  if (body) {
    return body;
  }
  let json = bodyJson;
  if (typeof json === 'string') {
    try {
      json = JSON.parse(json);
    } catch (e) {
      return '';
    }
  }
  const renderedHtml = json?.renderedHtml;
  if (typeof renderedHtml === 'string' && renderedHtml) {
    return renderedHtml;
  }
  return renderedHtml?.body || (typeof json?.html === 'string' ? json.html : '');
}
